module.exports = __webpack_public_path__ + "img/logo_poweredby.63072c36.gif";